import React, { useEffect, useState } from "react";
import { ProjectCard } from "../components/ProjectCard";
import { generateClient } from "aws-amplify/api";
import {
  listSlumSoccerProjects,
} from "../graphql/queries";

const client = generateClient();

const getProjectDate = (project) => {
  try {
    // Check if ef1 exists and is a string before parsing
    const ef1 = typeof project.ef1 === 'string' 
      ? JSON.parse(project.ef1) 
      : project.ef1;
    
    // Parse date, handling potential different formats
    return ef1?.date ? new Date(ef1.date) : new Date(0);
  } catch (error) {
    console.error(`Error parsing date for project:`, project);
    return new Date(0);
  }
};

export function Projects(props) {
  const [data, setData] = useState([]);

  useEffect(() => {
    fetchData();
    window.scrollTo(0, 0);
  }, []);

  const fetchData = async () => {
    try {
      let pendingData = await client.graphql({
        query: listSlumSoccerProjects,
      });

      const rawProjects = pendingData["data"]["listSlumSoccerProjects"].items;

      const sortedProjects = rawProjects.sort((a, b) => {

        // Compare dates
        const dateA = getProjectDate(a);
        const dateB = getProjectDate(b);

        return dateB - dateA; // Newest first
      });

      setData(sortedProjects);
    } catch (error) {
      console.error("Error fetching or sorting projects:", error);
    }
  };

  return (
    <>
      <section className="py-16 bg-gradient-to-b from-gray-50 to-gray-100 animate__animated animate__bounceInUp">
        <div className="container mx-auto px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-orange-500 relative inline-block -mt-5">
              Our Projects
              <div className="h-1 w-full bg-orange-500 mt-2"></div>
            </h2>
            <p className="text-gray-600 mt-4 max-w-2xl mx-auto">
              Discover impactful activities that transform communities.
              Creating change, inspiring futures

            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {data.map((project) => (
              <ProjectCard key={project.projectid} project={project} />
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
